import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import '../estilo/LanguageSelector.css'; // Importamos sus estilos limpios
import { useNavigate } from 'react-router-dom';

const LanguageSelector = () => {
    const [langOpen, setLangOpen] = useState(false);
    const [selectedLang, setSelectedLang] = useState('English');
    const navigate = useNavigate();

    const languages = [
        { code: 'en', name: 'English' },
        { code: 'es', name: 'Español' }
    ];

    const handleLanguageChange = (langCode, langName) => {
        setSelectedLang(langName);
        setLangOpen(false);
        // Forzamos la recarga completa apuntando al subdirectorio correcto en el servidor
        //alert("11")
        window.location.href = `https://www.powerbits.net/${langCode}/`;

        console.log(`Redireccionando a proyecto: ${langName} (/${langCode})`);
    };

    return (
        <div className="lang-container">
            <button onClick={() => setLangOpen(!langOpen)} type="button" className="lang-btn">
                {/* SVG FontAwesome fa-globe */}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" className="lang-globe"><path d="M415.9 344L225 344C227.9 408.5 242.2 467.9 262.5 511.4C273.9 535.9 286.2 553.2 297.6 563.8C308.8 574.3 316.5 576 320.5 576C324.5 576 332.2 574.3 343.4 563.8C354.8 553.2 367.1 535.8 378.5 511.4C398.8 467.9 413.1 408.5 416 344zM224.9 296L415.8 296C413 231.5 398.7 172.1 378.4 128.6C367 104.2 354.7 86.8 343.3 76.2C332.1 65.7 324.4 64 320.4 64C316.4 64 308.7 65.7 297.5 76.2C286.1 86.8 273.8 104.2 262.4 128.6C242.1 172.1 227.8 231.5 224.9 296zM176.9 296C180.4 210.4 202.5 130.9 234.8 78.7C142.7 111.3 74.9 195.2 65.5 296L176.9 296zM65.5 344C74.9 444.8 142.7 528.7 234.8 561.3C202.5 509.1 180.4 429.6 176.9 344L65.5 344zM463.9 344C460.4 429.6 438.3 509.1 406 561.3C498.1 528.6 565.9 444.8 575.3 344L463.9 344zM575.3 296C565.9 195.2 498.1 111.3 406 78.7C438.3 130.9 460.4 210.4 463.9 296L575.3 296z" /></svg>
                <span>{selectedLang}</span>
                <ChevronDownIcon className={`lang-arrow ${langOpen ? 'open' : ''}`} aria-hidden="true" />
            </button>

            {langOpen && (
                <div className="lang-dropdown">
                    {languages.map((lang) => (
                        <button
                            key={lang.code}
                            onClick={() => handleLanguageChange(lang.code, lang.name)}
                            className={`lang-item ${selectedLang === lang.name ? 'active' : ''}`}

                        >
                            {lang.name}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;